import React from "react"
import { Line } from "react-chartjs-2"
import "chartjs-plugin-annotation"

import { TinyColor } from "@ctrl/tinycolor"
import { formatCurrency } from "../helpers/functions"

export default class LineGraph extends React.Component {
  render() {
    const { data, annotations = [] } = this.props
    return (
      <div>
        <Line
          data={data}
          options={{
            annotation: {
              drawTime: "afterDatasetsDraw",
              annotations,
            },
            legend: {
              labels: {
                usePointStyle: true,
              },
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    callback: value => formatCurrency(value),
                  },
                },
              ],
            },
            tooltips: {
              callbacks: {
                label: (tooltipItem, data) => {
                  var label =
                    data.datasets[tooltipItem.datasetIndex].label || ""

                  if (label) {
                    label += ": "
                  }
                  label += formatCurrency(tooltipItem.yLabel)
                  return label
                },
              },
            },
          }}
        />
      </div>
    )
  }
}

export const makeChartConfiguration = ({
  label,
  fill = true,
  dashed = false,
  pointRadius = 4,
  color: rawColor = "rgba(255, 84, 58, 1.0)",
}) => {
  const color = new TinyColor(rawColor)
  return {
    label,
    fill,
    lineTension: 0.1,
    backgroundColor: color.lighten(30).toString(),
    borderColor: color.toString(),
    borderCapStyle: "butt",
    borderDash: dashed ? [10, 5] : [],
    borderDashOffset: 0.0,
    borderJoinStyle: "miter",
    pointBorderColor: color.lighten().toString(),
    pointBackgroundColor: color.toString(),
    pointBorderWidth: 1,
    pointHoverRadius: pointRadius,
    pointHoverBackgroundColor: color.complement().toString(),
    pointHoverBorderColor: color.complement().toString(),
    pointHoverBorderWidth: 2,
    pointRadius,
    pointStyle: "dot",
    pointHitRadius: 10,
    data: [],
  }
}
